import { Component } from '@theme/component';

const WISHLIST_STORAGE_KEY = 'wishlist';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} wishlistBubble
 * @property {HTMLElement} wishlistBubbleText
 * @property {HTMLElement} wishlistBubbleCount
 *
 * @extends {Component<Refs>}
 */
class WishlistIcon extends Component {
  requiredRefs = ['wishlistBubble', 'wishlistBubbleText', 'wishlistBubbleCount'];

  connectedCallback() {
    super.connectedCallback();
    this.updateFromStorage();
    document.addEventListener('wishlist:update', this.updateFromStorage);
    window.addEventListener('storage', this.onStorage);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('wishlist:update', this.updateFromStorage);
    window.removeEventListener('storage', this.onStorage);
  }

  /**
   * @param {StorageEvent} event
   */
  onStorage = (event) => {
    if (event.key === WISHLIST_STORAGE_KEY) {
      this.updateFromStorage();
    }
  };

  /**
   * @returns {number}
   */
  static getCount() {
    try {
      const data = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');

      if (!Array.isArray(data)) return 0;

      return data.filter((item) => item && item.productTitle && item.productUrl).length;
    } catch {
      return 0;
    }
  }

  updateFromStorage = () => {
    const count = WishlistIcon.getCount();

    this.refs.wishlistBubbleCount.textContent = count > 0 && count < 100 ? String(count) : '';
    this.refs.wishlistBubbleCount.classList.toggle('hidden', count === 0);
    this.refs.wishlistBubble.classList.toggle('visually-hidden', count === 0);
    this.classList.toggle('wishlist-icon--has-items', count > 0);
  };
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
